import ImagesData from '@assets/ImagesData';
import { IoLocationOutline, MdKeyboardArrowDown, MdModeEditOutline, TbCloudUpload } from '@assets/Icons'
import SearchBar from '@components/searchBar/SearchBar';

import { useEffect, useMemo, useState } from "react";
// import { Imagesdata } from "../../assets/images/imageData";
import {
  authenticationSeletor,
  loginSuccess,
  setLocalProfileImg,
} from "@store/slices/authenticationSlice";
import { useDispatch, useSelector } from "react-redux";
import services from "@api/services";
import Moment from "react-moment";
import Slider from "react-slick";


import { Rating } from "@smastrom/react-rating";
import { useForm, Controller, useFieldArray } from "react-hook-form";

import "@smastrom/react-rating/style.css";
import { baseImgUrl, baseUrl } from "@api/client/api";
import { toast } from "react-toastify";
import { onLogout, showPrice } from "@utils/utils";
import SklHotelCard from "@shared/skeleton/SklHotelCard";
import { createKotLogs, createLogs } from "@store/slices/PropertyData";
import moment from "moment";
import ReactGA from "react-ga4";
import { ImSpoonKnife } from "react-icons/im"
import { FOOD_PLAN, statusfoodColor, ROOM_CATEGORY_COLOR, PROPERTY_CATEGORY_COLORS } from '@constant/constants';
import ReactPaginate from "react-paginate";
import axios from "axios";
import { Link, useNavigate, useLocation } from 'react-router-dom';

const UserProfile = () => {

  // const { WalletIcon, popularSliderImg, UserlogoutIcon, AlertIcon, userImg } =
  //   Imagesdata || {};

  const settingsImgSlider = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: true,
  };

  const [roomNumbers, setRoomNumbers] = useState([]);
  const [foodItems, setFoodItems] = useState([]);
  const [orderAmt, setOrderAmt] = useState(0);
  const [show, setShow] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const { userDetail } = useSelector(authenticationSeletor);
  const [bookedHotel, setBookedHotel] = useState([]);
  const [hotelPagination, setHotelPagination] = useState({})
  const [showBookings, setShowBookings] = useState([]);
  const [rating, setRating] = useState(0); // Initial value
  const [reviewBox, setReviewBox] = useState(0);
  const [cancelPopup, setCencelPopup] = useState(0);
  const [reasonVal, setReasonVal] = useState("");
  const [openFoodPopup, setOpenFoodPopup] = useState("");
  const [menuCards, setMenuCards] = useState([]);
  const [showInd, setShowInd] = useState([]);
  const [filterBar, setFilterBar] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [filterFoodItems, setFilterFoodItems] = useState([]);
  const [qty, setQty] = useState([]);
  const [allFoodOrders, setAllFoodOrders] = useState([]);
  const [cancleModal, setCancleModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [cancleData, setCancleData] = useState([]);
  const [referAmt, setReferAmt] = useState({});
  const [checkReview, setReviewCheck] = useState({
    first: "",
    second: "",
    third: "",
    fourth: "",
    fifth: "",
    sixth: "",
  });

  const [sortValue, setSortValue] = useState("");
  const [oldNew, setOldNew] = useState(-1);
  const [imgFile, setImgFile] = useState(null);
  const [showUser, setShowUser] = useState({});
  const [userData, setUserData] = useState({
    name: showUser?.name ?? userDetail?.name,
    img: "",
    email: showUser?.email ?? userDetail?.email,
  });
  const [userOtherData, setUserOtherData] = useState({
    company: '',
    gst: '',
    address: ''
  })
  const [editSave, setEditSave] = useState(false);
  const [gstDetails, setGstDetails] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  let forMobileView = location?.state?.activeTab || 'both'

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const { searchItems, selectedFoodItems } = watch();

  const { fields, append, remove, update } = useFieldArray({
    name: "selectedFoodItems",
    control,
  });

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "customer_profile" });
    // getBookedHotel();
  }, []);

  const onSubmit = async (payload) => {
    if (!rating) {
      toast.error("Please select star to rating");
      return;
    }
    const realPayload = {
      user_id: payload.userId,
      bookingCode: payload.bookingCode,
      fromDate: moment(payload.fromDate).format("YYYY-MM-DD"),
      toDate: moment(payload.toDate).format("YYYY-MM-DD"),
      property_id: payload.propertyId,
      ratings: rating,
      reviews: payload.enterReview,
    };
    try {
      const res = await services.globalService.createCustomerReviewService(
        realPayload
      );
      if (res.status === 201) {
        setReviewBox(0);
        reset();
        setRating(0);
      }
    } catch (error) { }
  };

  const getRoomCategory = async () => {
    try {
      const res = await services.property.getRoomCategoryService();
      if (res.status === 200) {
        setCategoryData(res?.data?.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getRoomCategory()
  }, [])

  const limit = 10
  const [page, setPage] = useState(1)

  const getBookedHotel = async () => {
    setLoading(true);
    try {
      const res = await services.property.getBookHotelByUser(userDetail.id, page, limit);
      if (res.status === 200) {
        setBookedHotel(res?.data?.data);
        setHotelPagination(res?.data?.pagination)
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const checkOutHandler = async (e, data) => {
    e.preventDefault();
    try {
      let arr = [];
      for (let i in checkReview) {
        arr.push(checkReview[i]);
      }
      const payload = {
        id: data.id,
        cancelledBy: `guest_${userDetail?.name}_${userDetail?.mobile}`,
        body: {
          bookingStatus: 4,
          reason: arr.toString() + " " + reasonVal,
        },
      };
      // checkReview

      const res = await services.globalService.updateCheckInStatusService(
        payload
      );
      if (res.status === 200) {
        const reasonValues = Object.values(checkReview).filter((val) => val && val.trim() !== "");
        const params = {
          bookingId: data.id,
          action: `Booking Cancelled  - ${reasonValues.join(", ")}`,
          actionType: `Booking Cancelled`,
          actionBy: userDetail?.name,
          userType: "Guest",
          cancelBy: "guest",
          paymentMode: null,
          // propertyId: hoterData?.propertyId,
        };
        dispatch(createLogs(params));
        setCencelPopup(0);
        getBookedHotel();
        setReasonVal("");
      }
    } catch (error) { }
  };

  const setCheckReview = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setReviewCheck({ ...checkReview, [name]: value });
  };

  const setShowSection = (ind) => {
    if (showInd.includes(ind)) {
      setShowInd((i) => i.filter((i) => i !== ind));
    } else {
      setShowInd([ind]);
    }
  };
  useEffect(() => {
    // getRecentBooking();
    window.scrollTo(0, 0);
    //  let c = document.getElementById("myCanvas");
    //  let ctx = c.getContext("2d");
    //  let img = document.getElementById("preview");
    //  ctx.drawImage(img, 10, 10);
    //  alert(c.toDataURL());
  }, []);

  // adding food items to food order modal
  const handleAddItem = async (item) => {
    const tempPrice = item?.finalPrice || item?.price;
    if (fields.some((i) => i.itemId == item.id)) {
      quantityHanlder(
        fields.find((i) => i.itemId == item.id),
        0,
        true
      );
    } else {
      append({
        itemId: +item.id,
        name: item.name,
        price: tempPrice,
        qty: 1,
        amountBeforeTax: item?.amountBeforeTax,
        taxAmount: item?.taxAmount * 1,
        propertyId: item?.propertyId,
        totalAmount: tempPrice * 1,
        gstPercentage: item.gstPercent
      });
    }
  };

  // remove food order in  food order modal
  const deleteItem = (index) => {
    if (window.confirm("Are you sure to delete this item?")) {
      remove(index);
    }
  };
  // quantity handler for food order
  const quantityHanlder = async (item, index, isIncrement) => {
    let temp = item;
    if (isIncrement) {
      temp.qty++;
      temp.totalAmount = temp.price * temp.qty;
    } else {
      if (item.qty > 1) {
        temp.qty--;
        temp.totalAmount = temp.price * temp.qty;
      } else {
        deleteItem(index);
        return;
      }
    }

    update(index, temp);
  };

  const getUserData = async () => {
    try {
      const res = await services.auth.getUserDetails(userDetail?.id);
      if (res.status === 200) {
        setShowUser(res.data.data);
        setUserData({
          name: res?.data?.data?.name,
          img: "",
          email: res?.data?.data?.email,
          profileImage: res?.data?.data?.profileImage
        });

        setUserOtherData({
          ...userOtherData,
          company: res?.data?.data.company,
          gst: res?.data?.data.gst,
          address: res?.data?.data.address
        })

        setImgFile(res?.data?.data?.profileImage);
        dispatch(setLocalProfileImg(res?.data?.data?.profileImage))
        
      }
    } catch (error) { }
  };
  useEffect(() => {
    getUserData();
  }, []);

  const checkRatingDone = async (data) => {
    // if (data.id == reviewBox) {
    //   setReviewBox(0);
    // } else {
    //   setReviewBox(data.id);
    // }
    // reset();
    // setRating(0);
    // return;
    try {
      const res = await fetch(
        `${baseUrl}rrooms-property/ratings?bookingCode=${data?.bookingCode}`
      );
      const rating = await res.json();
      if (rating?.data?.find((i) => i.userId == userDetail?.id)?.id) {
        toast.warning("You have Already Rated this Booking*", {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
      } else {
        setReviewBox(data.id);
        reset();
        setRating(0);
      }
    } catch (error) { }
  };


  useEffect(() => {
    if (editSave) {
      setValue("company", userOtherData.company);
      setValue("gst", userOtherData.gst);
      setValue("address", userOtherData.address);
    }
  }, [editSave, setValue]);

  const editHandler = async (data) => {
    // setBtnClick(0);
    const foodResponse = await services.property.getFoodItemsProperty(
      `?property_id=${data?.propertyId}`
    );
    if (foodResponse.status === 200) {
      setFoodItems(foodResponse.data.data);
      setFilterFoodItems(foodResponse.data.data);
    }
    setSelectedData(data);
    setShow(true);
    const rooms = data.assignRoomNo?.split(",");
    setRoomNumbers(rooms);
    if (rooms) {
      setValue("roomNo", rooms[0]);
    }
  };

  const getMenuCards = async (id) => {
    try {
      const res = await services.globalService.getMenuCardByIdService(id);
      if (res.status === 200) {
        setMenuCards(res.data.data);
        setOpenFoodPopup(true);
      }
    } catch (error) { }
  };

  // const changeHandler = (e, data) => {
  //   if (e.target.checked) {
  //     setSelectedFoods([
  //       ...selectedFoods,
  //       {
  //         id: Number(e.target.value),
  //         price: data.price,
  //       },
  //     ]);
  //     setQty([...qty, { id: Number(e.target.value), qtyValue: 1 }]);
  //   } else {
  //     const resultfilter = selectedFoods.filter((d, index) => {
  //       return d.id !== Number(e.target.value);
  //     });
  //     setQty(qty.filter((i) => i.id !== data.id));
  //     setSelectedFoods(resultfilter);
  //   }
  // };
  // const foodItemsFilter = (ind, item) => {
  //   setBtnClick(ind);
  //   setFilterFoodItems(foodItems.filter((i) => i.categoryId === item.id));
  // };

  const getTotalFoodBooking = async () => {
    const res = await services.property.getFoodOrders();
    if (res.status === 200) {
      const filterData = res.data.data.filter(
        (item) => item.userId === userDetail.id
      );
      setAllFoodOrders(filterData);
    }
  };

  const [amountBeforeGst, setAmountBeforeGst] = useState(0);

  useEffect(() => {
    getTotalFoodBooking();
  }, []);



  useEffect(() => {
    let totalAmountBeforeGst = 0;
    selectedFoodItems?.map((item) => {
      totalAmountBeforeGst += item.amountBeforeTax;
    });
    setAmountBeforeGst(totalAmountBeforeGst);
  }, [selectedFoodItems]);

  const onSubmitfood = async (payload) => {
    if (payload.selectedFoodItems.length < 1) {
      toast.error("Please Select Food Items*", {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
      return;
    }
    const items = payload.selectedFoodItems.map((item) => {
      const temp = {
        ...item,
        id: item.itemId,
      };
      delete temp.itemId;
      return temp;
    });


    const realPayload = {
      user_id: selectedData?.userId,
      booking_id: selectedData.id,
      room_number: payload.roomNo,
      order_amount: orderAmt,
      order_items: items,
      created_by: 0,
      otherGuestName: userDetail.name,
      nc_type: "Room Service",
      propertyId: selectedData.propertyId,
      totalFoodAmountBeforeGST: amountBeforeGst,
      remark: payload.remark
    };
    try {
      const res = await services.property.createFoodOrders(realPayload);
      if (res.status === 200) {
        getBookedHotel();
        getTotalFoodBooking();
        hideFoodBookingModal();

        const params = {
          action: `KOT created`,
          actionBy: `Guest(${userDetail?.name})`,
          operation: `Created, KOT Type - (Room Service -${selectedData?.assignRoomNo})
          Order Items - (${items?.map((data) => { return ` ${data.name}` })} ),
          Amount - (₹${orderAmt})`,
          propertyId: selectedData?.propertyId,
          bookingCode: res?.data?.data?.id
        }
        dispatch(createKotLogs(params));
      }
    } catch (error) { }
  };

  const hideFoodBookingModal = () => {
    setShow(false);
    reset();
    setOrderAmt(0);
    remove([]);
  };

  const filterFoodItemsToShow = (query) => {
    let text = query?.toLowerCase();
    const results = foodItems.filter((item) => {
      if (text == "") return foodItems;

      return (item.itemCode + item.name).toLowerCase().includes(text);
    });
    setFilterFoodItems(results);
  };



  useEffect(() => {
    if (searchItems) {
      filterFoodItemsToShow(searchItems);
    }
  }, [searchItems]);
  useEffect(() => {
    if (selectedFoodItems) {
      setOrderAmt(
        selectedFoodItems.reduce((acc, arr) => acc + arr.price * arr.qty, 0)
      );
    }
  }, [selectedFoodItems]);

  const cancleFoodOrder = async (item) => {
    try {
      if (!window.confirm("Are You Sure Want to Cancle Order")) {
        return;
      }
      const realPayload = {
        order_status: 4,
      };
      const res = await services.property.updateFoodOrderStatus(
        realPayload,
        item.id
      );
      if (res.status == 200) {
        setCancleData(cancleData.filter((i) => i.id === item.id));
        getBookedHotel();
        getTotalFoodBooking();
        toast.success("Food Order Cancel Successfull !", {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
      }
    } catch (error) { }
  };

  const cancleSetup = (data) => {
    setCancleData(data);
    setCancleModal(true);
  };

  const paymentFromUser = async (item) => {
    try {
      const res = await services.property.paymentGateway(item?.id);
      if (res.status === 200) {
        window.open(
          res.data.data.data.instrumentResponse.redirectInfo.url,
          "_blank"
        );
      }
    } catch (error) { }
  };

  const referalHandler = async () => {
    try {
      const res = await services.property.getwalletMoney(userDetail?.id);
      if (res.status === 200) {
        setReferAmt(res.data.data[0]);
      }
    } catch (error) { }
  };


  useEffect(() => {
    referalHandler();
  }, []);
  const saveEditHandler = async (payload) => {
    if (editSave) {
      const { address, company, gst } = payload;
      try {
        const formData = new FormData();
        formData.append("name", userData.name ?? "");
        formData.append("email", userData.email ?? "");
        formData.append("profileImage", userData.img);
        formData.append("address", address);
        formData.append("company", company);
        formData.append("gst", gst);
        const body = {
          id: userDetail?.id,
          data: formData,
        };
        const res = await services.auth.updateUser(body);
        if (res.status === 200) {
          dispatch(
            loginSuccess({
              data: {
                ...userDetail,
                logintype: "normalUser",
                name: userData.name,
                email: userData.email,
                gst,
                company,
                address,
              },
            })

          );
          getUserData();
          reset();
        }
      } catch (error) { }
    }
    setEditSave(!editSave);
    setGstDetails(!editSave);
  };

  useEffect(() => {
    if (sortValue == "") {
      setShowBookings(bookedHotel);
    } else {
      const filterBookings = bookedHotel?.filter(
        (i) => i.bookingStatus == sortValue
      );
      setShowBookings(filterBookings);
    }
  }, [sortValue, bookedHotel]);
  useMemo(() => {
    let filterVal = [];
    if (oldNew == 1) {
      filterVal = bookedHotel.sort(function (a, b) {
        var keyA = new Date(a.createdAt),
          keyB = new Date(b.createdAt);
        if (keyA > keyB) return -1;
        if (keyA < keyB) return 1;
        return 0;
      });
    } else if (oldNew == 0) {
      filterVal = bookedHotel.sort(function (a, b) {
        var keyA = new Date(a.createdAt),
          keyB = new Date(b.createdAt);
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });
    }
    filterVal = bookedHotel;
    setShowBookings(filterVal);
  }, [oldNew]);


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    getBookedHotel();
  }, [page])


  const bookHandler = async (bookId) => {
    try {
      let paymentType = 'Full'
      const bookRes = await services.property.updateBookingModeStatus(
        bookId,
        {
          status: 1,
          paymentMode: 1,
          paymentAmount: paymentType
        }
      );

      if (bookRes.status == 200) {
        const res = await services.property.paymentGateway(bookId, paymentType)
        openRazorpay(res?.data?.data?.order_id, res?.data?.data?.amount, paymentType, bookId)
      }
    } catch (error) { }
  };




  const openRazorpay = async (orderId, amount, paymentType, bookingId) => {
    let db_amount = amount / 100
    const options = {
      key: 'rzp_live_Eqmw0XU2XIG31l',
      amount: amount,
      currency: "INR",
      name: "RROOMS",
      description: "RRooms Hotel Booking Payment",
      image: "https://rrooms.in/logo.webp",
      order_id: orderId,
      handler: async function (response) {
        let newRes = await axios.post(`https://rrooms.in/rrooms/api/rrooms-property/razorpay-status-update?booking_id=${bookingId}&paymentType=${paymentType}&paidAmount=${db_amount}&userId=${userDetail?.id}&dueAmount=${paymentType == 'Full ' ? 0 : bookedHotel?.dueAmount - db_amount} `, {
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        });
        // alert("Payment successful and verified!");
        if (newRes.status === 200) {
          navigate(`/booking-confirm/${bookedHotel?.id}`);
        }
      },
      prefill: {
        name: userDetail?.name,
        email: userDetail?.email,
        contact: userDetail?.mobile
      },
      theme: {
        color: "#fb961b"
      },
      modal: {
        ondismiss: function () {
          navigate(`/user-profile`);
        }
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };



  return (
    <>
      <div className='inner-searchBar bg-gray section-sm'>
        <div className='container'>
          <SearchBar />
        </div>
      </div>
      <div className='profile-page'>
        <div className='container'>
          <div className='row'>
            {
              (forMobileView == 'profile' || forMobileView == 'both') && (
                <div className='col-lg-4'>
                  <div className='profile-card'>
                    <div className='avatar border-bottom text-center'>
                      <button
                        type='button'
                        className={`btn-action btn-action-secondary ${editSave ? 'active btn-action-success' : ''}`}
                        onClick={handleSubmit(saveEditHandler)}>
                        {
                          editSave ? (
                            <>
                              Save
                            </>
                          ) : (
                            <MdModeEditOutline size={18} />
                          )
                        }
                      </button>
                      <span className={`img ${editSave && "active"}`}>
                        <img src={(editSave && userData?.img) ? imgFile : imgFile ? `${baseImgUrl}${imgFile}` : ImagesData?.ImgProfile?.src} />
                        <input
                          type="file"
                          id="userImg"
                          className='file'
                          disabled={editSave ? false : true}
                          onChange={(e) => {
                            if (e.target.files.length > 0) {
                              setImgFile(URL.createObjectURL(e.target.files[0]));
                              setUserData({ ...userData, img: e.target.files[0] });
                            }
                          }}
                          accept="img/png"
                        />
                        <span className='icon'>
                          <TbCloudUpload size={34} />
                        </span>
                      </span>
                      <h3>
                        <input
                          onChange={(e) =>
                            setUserData({ ...userData, name: e.target.value })
                          }
                          type="text"
                          disabled={editSave ? false : true}
                          value={userData.name ?? "Your Name"}
                          className={editSave ? "activeInput input-box" : " input-box"}
                        />
                      </h3>
                      <h5 className='text-light'>Referral Code : {userDetail?.referralCode}</h5>
                    </div>
                    <div className='info'>
                      <div className='box'>
                        <p className='fs-6'>Phone number</p>
                        <h5>
                          <input
                            type="number"
                            disabled
                            value={userDetail ? userDetail.mobile : ""}
                            className='input-box'
                          />
                        </h5>
                      </div>
                      <div className='box'>
                        <p className='fs-6'>Email address</p>
                        <h5 className='text-secondary'>
                          <input
                            onChange={(e) =>
                              setUserData({ ...userData, email: e.target.value })
                            }
                            type="email"
                            className={editSave ? "activeInput input-box" : " input-box"}
                            disabled={editSave ? false : true}
                            value={userData.email}
                          />
                        </h5>
                      </div>
                      {
                        userOtherData &&
                        <>
                          <div className='box'>
                            <p className='fs-6'>Company name</p>
                            <h5>{userOtherData?.company}</h5>
                          </div>
                          <div className='box'>
                            <p className='fs-6'>{userOtherData?.gst}</p>
                            <h5>0987-09876-9876</h5>
                          </div>
                          <div className='box'>
                            <p className='fs-6'>Address</p>
                            <h5>{userOtherData?.address}</h5>
                          </div>
                        </>
                      }

                      {/* {
                    !userOtherData && <button
                      className="addGstButton"
                      onClick={() => {
                        setGstDetails(!gstDetails);
                        setEditSave(true);
                      }}
                    >
                      {gstDetails ? "hide" : "Add"} Gst Details
                    </button>
                  } */}

                      {/* <div
                    className="gstDetailsAdd"
                    style={{
                      display: gstDetails ? "block" : "block",
                    }}
                  >
                    <div className="form-group">
                      <label>Company Name</label>
                      <input
                        type="text"
                        id="company"
                        className='form-control'
                        autoFocus
                        placeholder="Enter Company Name"
                        {...register("company", { required: "Company name is required" })}
                      />
                      {errors.company && (
                        <p className="text-danger fs-7">{errors.company.message}</p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Company Address</label>
                      <input
                        type="text"
                        id="address"
                        autoFocus
                        placeholder="Enter Company Name"
                        {...register("address", { required: "Company name is required" })}
                      />
                      {errors.address && (
                        <p className="text-danger fs-7">{errors.address.message}</p>
                      )}
                    </div>
                    <div className="form-group">
                      <label>GST Number</label>
                      <input
                        type="text"
                        id="gst"
                        autoFocus
                        placeholder="Enter GST Number"
                        {...register("gst", { required: "Company name is required" })}
                      />
                      {errors.gst && (
                        <p className="text-danger fs-7">{errors.gst.message}</p>
                      )}
                    </div>
                  </div> */}


                      <div className='flex justify-content-between pt-4 pb-4'>
                        <button type='button' className='btn btn-danger'>Delete Account</button>
                        {
                          userDetail?.mobile && (
                            <button type='button' className='btn btn-secondary' onClick={() => onLogout(navigate)}>Logout</button>
                          )
                        }

                      </div>
                    </div>
                    <div className='wallet bg-secondary-light border-top p-3'>
                      <div className='flex'>
                        <div className='left mr-3'>
                          <img src={ImagesData?.IconWallet?.src} title='' alt='' />
                        </div>
                        <div className='text'>
                          <h4 className='text-brand'>RROOMS Money</h4>
                          <h5 className='fs-2 text-success line-height-1'>₹ {referAmt?.balance?.toFixed(2) ?? "0.00"}</h5>
                          <p>Wallet Available Balance</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )

            }
            {
              (forMobileView == 'bookings' || forMobileView == 'both') && (
                <div className='col-lg-8'>
                  <div className='booking-history'>
                    <h2>Booking History</h2>
                    <div className='booking-tabs d-flex align-items-center justify-content-between mt-4 mb-4'>
                      <ul>
                        <li
                          className={sortValue === "" ? "active" : ""}
                          onClick={() => setSortValue("")}
                        >
                          All Bookings
                        </li>
                        <li
                          className={sortValue === "1" ? "active" : ""}
                          onClick={() => setSortValue("1")}
                        >
                          Upcoming
                        </li>
                        <li
                          className={sortValue === "3" ? "active" : ""}
                          onClick={() => setSortValue("3")}
                        >
                          Completed
                        </li>
                        <li
                          className={sortValue === "4" ? "active" : ""}
                          onClick={() => setSortValue("4")}
                        >
                          Cancelled
                        </li>
                      </ul>

                      <select
                        id="sortType"
                        name="sort"
                        className='field-control only-mobile'
                        onChange={(e) => setSortValue(e.target.value)}
                      >
                        <option value="" selected={sortValue == "" ? true : false}>
                          {sortValue == "" ? "Select " : "Clear "}Filter
                        </option>
                        <option value="1" selected={sortValue == 1 ? true : false}>
                          Upcoming
                        </option>
                        <option value="4" selected={sortValue == 4 ? true : false}>
                          Cancelled
                        </option>
                        <option value="3" selected={sortValue == 3 ? true : false}>
                          Complete
                        </option>
                      </select>

                      <select
                        className='field-control'
                        id="sortType"
                        name="sort"
                        onChange={(e) => setOldNew(e.target.value)}
                      >
                        <option value="">Sort By</option>
                        <option value="0">Old To New</option>
                        <option value="1">New To Old</option>
                      </select>
                    </div>

                    {
                      loading ? (
                        <SklHotelCard />
                      ) :
                        showBookings?.map((data, key) => {
                          let roomCategory = categoryData.find((cate) => cate.id == data.propertyRoomsCategoryId)
                          return (
                            <div className='booking-card' key={key}>

                              <span
                                className={`tag`}
                                style={{ backgroundColor: PROPERTY_CATEGORY_COLORS[data?.PropertyMaster?.PropertyCategory?.id] }}>
                                {data?.PropertyMaster?.PropertyCategory?.name}
                              </span>

                              <div className='img'>
                                {
                                  data?.PropertyMaster ?
                                    <Link to={`${data?.PropertyMaster?.city == "Lucknow" ? '/hotels-in-lucknow' : '/hotel-details'}/${data?.PropertyMaster?.slug.replace(/^\//, '')}`}>
                                      <img
                                        src={
                                          data?.PropertyMaster?.PropertyImages?.length
                                            ? `${baseImgUrl}${data?.PropertyMaster?.PropertyImages[0].image}`
                                            : ''
                                        }
                                        alt=""
                                      />
                                    </Link> :
                                    null
                                }
                              </div>
                              <div className='info'>
                                <h4>
                                  <Link to={`${data?.PropertyMaster?.city == "Lucknow" ? '/hotels-in-lucknow' : '/hotel-details'}/${data?.PropertyMaster?.slug.replace(/^\//, '')}`}>
                                    {data.PropertyMaster?.name}
                                  </Link>
                                  {
                                    data?.bookingType == "Hourly" &&
                                    <span className='bedge ml-1'>{data?.bookingType}</span>
                                  }
                                </h4>
                                <h6 className='fs-7 text-light pt-2 pb-2'>
                                  <Moment format="DD MMM YYYY">
                                    {data.fromDate}
                                  </Moment>{" to "}
                                  <Moment format="DD MMM YYYY">{data.toDate}</Moment>
                                  {
                                    data?.bookingType == "Hourly" ?
                                      <>
                                        ,
                                        <span className='fw-bold ml-3'>{data?.bookingSlot}s</span>,
                                        <span className='fw-bold ml-3'>{data?.bookingHours}</span>
                                      </> : ''
                                  }
                                </h6>
                                <h6 className='fs-7'>{data?.adults} Adult | {data?.children} Child | {data?.noOfRooms} Room</h6>
                                <div className='v-center pt-3 pb-3'>
                                  <span className='btn-mat btn-mat-primary'>{roomCategory?.name}</span>
                                  <p className='fs-7 fw-semibold ml-2'>Meal Plan : {FOOD_PLAN[data.breakFast] ?? 'Unknown Food Plan'}</p>
                                </div>
                                {
                                  data.PropertyMaster?.address &&
                                  <Link
                                    className='v-center text-secondary'
                                    to={`https://maps.google.com/maps?q=${data?.PropertyMaster?.latitude},${data?.PropertyMaster?.longitude}&hl=es;z=14&amp;output=embed`}
                                    target="_deepak">
                                    <IoLocationOutline size={18} className='mr-1' />
                                    {data.PropertyMaster?.address.slice(0, 45)}
                                  </Link>
                                }

                              </div>
                              <div className='all-actions'>
                                <div className='actions'>
                                  <div className='box'>
                                    <h5 className='fs-7 fw-normal'>Booking ID:</h5>
                                    <h6>{data.bookingCode}</h6>
                                  </div>
                                  <div className='box'>
                                    {/* <p className='text-h fs-7 mb-2'>Booking Status</p> */}
                                    {/* <button type='button' className='btn btn-primary'>Checked In</button> */}
                                    <span
                                      className={
                                        `fw-bold ${data.bookingStatus == 1
                                          ? "text-success"
                                          : data.bookingStatus == 2
                                            ? "text-warning"
                                            : data.bookingStatus == 3
                                              ? "text-secondary"
                                              : data.bookingStatus == 8
                                                ? "text-warning"
                                                : "text-danger"}`
                                      }
                                    >
                                      {data.bookingStatus == 1
                                        ? "Confirm Booking"
                                        : data.bookingStatus == 2
                                          ? "Checked In"
                                          : data.bookingStatus == 3
                                            ? "Checked Out"
                                            : data.bookingStatus == 4
                                              ? "Cancelled"
                                              : data.bookingStatus == 5
                                                ? "No-Show"
                                                : data.bookingStatus == 8
                                                  ? "Pending"
                                                  : data.bookingStatus == 7
                                                    ? "Rejected"
                                                    : "No Status"}
                                    </span>
                                    {data.bookingStatus == 1 && (
                                      <button
                                        variant="primary"
                                        className="btn btn-danger btn-sm mt-2"
                                        type="button"
                                        onClick={() => {
                                          if (cancelPopup) {
                                            setCencelPopup(0);
                                          } else {
                                            setCencelPopup(data.id);
                                          }
                                          setReasonVal("");
                                        }}
                                      >
                                        Cancel Booking
                                      </button>
                                    )}
                                  </div>
                                </div>
                                <div className='text-right pt-1'>
                                  <span
                                    className='fs-7 fw-semibold v-center cursor-pointer inline-flex'
                                    onClick={() => setShowSection(key)}>
                                    {
                                      showInd.find((i) => i === key) === key
                                        ? ""
                                        : (
                                          <><MdKeyboardArrowDown size={18} /> Show Details</>
                                        )
                                    }

                                  </span>
                                  {/* {
                              showInd.find((i) => i === key) === key ? 'Show Details' : 
                            } */}
                                </div>
                              </div>
                              {
                                showInd.find((i) => i === key) === key && (
                                  <div className='details d-flex'>
                                    <div className='w-40'>
                                      <h6>Other Details:</h6>
                                      <p>
                                        <span>Assign Room : </span>
                                        <span className='fw-semibold text-h'>{data.assignRoomNo ?? "N/A"}</span>
                                      </p>
                                      <p>
                                        <span>Booking ID : </span>
                                        <span className='fw-semibold text-h'>{data.bookingCode ?? "N/A"}</span>
                                      </p>
                                      <p>
                                        <span>Booking Amount : </span>
                                        <span className='fw-semibold text-h'>{data.bookingAmout ?? "N/A"}</span>
                                      </p>
                                      <p>
                                        <span>Booked By : </span>
                                        <span className='fw-semibold text-h'>{data.User?.name ?? "N/A"}</span>
                                      </p>
                                      <p>
                                        <span>Email : </span>
                                        <span className='fw-semibold text-h'>{data?.User?.email ?? "N/A"}</span>
                                      </p>
                                      <p>
                                        <span>Mobile : </span>
                                        <span className='fw-semibold text-h'>{data?.User?.mobile ?? "N/A"}</span>
                                      </p>
                                      <p>
                                        <span>Other Person Name : </span>
                                        <span className='fw-semibold text-h'>{data?.otherPersonName ?? "N/A"}</span>
                                      </p>
                                      <p>
                                        <span>Other Person Number : </span>
                                        <span className='fw-semibold text-h'>{data?.otherPersonNumber ?? "N/A"}</span>
                                      </p>
                                    </div>
                                    <div className='w-30'>
                                      <h6>Guest Details:</h6>
                                      {
                                        data?.GuestDetails?.length > 0 ? (
                                          data?.GuestDetails?.map((guest, ind) => (
                                            <>
                                              <p>
                                                <span>Name : </span>
                                                <span className='fw-semibold text-h'>{guest?.name ?? "N/A"}</span>
                                              </p>
                                              <p>
                                                <span>Gender : </span>
                                                <span className='fw-semibold text-h'>{guest?.gender ?? "N/A"}</span>
                                              </p>
                                              <p>
                                                <span>Document : </span>
                                                <span className='fw-semibold text-h'>{guest?.document_type ?? "N/A"}</span>
                                              </p>
                                              <p>
                                                <span>Document Number : </span>
                                                <span className='fw-semibold text-h'>{guest?.document_number ?? "N/A"}</span>
                                              </p>
                                            </>
                                          ))
                                        ) : <p>Guest Not Available !</p>
                                      }
                                    </div>
                                    <div className='w-100 text-right border-top pt-1 mt-1'>
                                      <span
                                        className='fs-7 fw-semibold v-center text-secondary cursor-pointer inline-flex'
                                        onClick={() => setShowSection(key)}>
                                        {
                                          showInd.find((i) => i === key) === key
                                            ? (<><MdKeyboardArrowDown size={18} />Less Details</>)
                                            : ""
                                        }

                                      </span>
                                    </div>
                                  </div>
                                )
                              }

                              {data.id == cancelPopup && (
                                <form
                                  className="canceled-form"
                                  onSubmit={(e) => checkOutHandler(e, data)}
                                >

                                  <div className='row'>
                                    <div className="col-lg-10 form-group d-flex justify-content-between"
                                    >
                                      <div className='list'>
                                        <input
                                          type="checkbox"
                                          name="first"
                                          value="Found a better price"
                                          id="source1"
                                          onChange={(e) => setCheckReview(e)}
                                        />
                                        <label htmlFor="source1">
                                          Found a better price
                                        </label>
                                      </div>
                                      <div className='list'>
                                        <input
                                          type="checkbox"
                                          name="second"
                                          value="Facing an issue at the property"
                                          id="source2"
                                          onChange={(e) => setCheckReview(e)}
                                        />
                                        <label htmlFor="source2">
                                          Facing an issue at the property
                                        </label>
                                      </div>
                                      <div className='list'>
                                        <input
                                          type="checkbox"
                                          name="third"
                                          value="property detail didn't match"
                                          id="source3"
                                          onChange={(e) => setCheckReview(e)}
                                        />
                                        <label htmlFor="source3">
                                          property detail didn't match
                                        </label>
                                      </div>
                                      <div className='list'>
                                        <input
                                          type="checkbox"
                                          name="fourth"
                                          value="property asked for additional money"
                                          id="source4"
                                          onChange={(e) => setCheckReview(e)}
                                        />
                                        <label htmlFor="source4">
                                          property asked for additional money
                                        </label>
                                      </div>
                                      <div className='list'>
                                        <input
                                          type="checkbox"
                                          name="fifth"
                                          value="Had a different issue"
                                          id="source5"
                                          onChange={(e) => setCheckReview(e)}
                                        />
                                        <label htmlFor="source5">
                                          Had a different issue
                                        </label>
                                      </div>
                                      <div className='list'>
                                        <input
                                          type="checkbox"
                                          name="sixth"
                                          value="Don't need this stay"
                                          id="source6"
                                          onChange={(e) => setCheckReview(e)}
                                        />
                                        <label htmlFor="source6">
                                          Don't need this stay
                                        </label>
                                      </div>
                                    </div>
                                    <div className="col-lg-12 form-group">
                                      <textarea
                                        // {...register("enterReason")}
                                        placeholder={"Enter Reason here"}
                                        className="form-control"
                                        name="enterReason"
                                        value={reasonVal}
                                        onChange={(e) => setReasonVal(e.target.value)}
                                      ></textarea>
                                    </div>
                                    <div
                                      className="col-lg-12"
                                    >
                                      <button
                                        className="btn btn-secondary btn-sm"
                                        type="submit"
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </div>

                                </form>
                              )}

                            </div>
                          )
                        })
                    }

                    {
                      <ReactPaginate
                        breakLabel="..."
                        nextLabel={"→"}
                        onPageChange={(event) => {
                          setPage(event.selected + 1);
                        }}
                        pageCount={hotelPagination?.totalPages}
                        forcePage={page - 1}
                        previousLabel={"←"}
                        className="pagination"
                        activeClassName="active"
                        disabledClassName="disablePaginationBtn"
                        renderOnZeroPageCount={null}
                      />
                    }
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default UserProfile